<template>
    <div class="blog-single__comments wrapper" id="comments-section">
        <div class="top">

            <h2>Comments <small>{{ commentCount }}</small></h2>

            <div class="blog-comment-cta-wrap" v-if="comments.length && currentUser">
                <button class="blog-comment-cta">
                    Add a Comment
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                </button>
            </div>

        </div>

        <div class="activity-feed">
            <div class="activity-feed-wrap">
                <div class="activity-feed-single active">

                    <div class="activity-item review-item" v-for="(comment, index) in comments" :id="`section-comment-${comment.id}`">

                        <!-- Profile Avatar -->
                        <div class="img-wrap">
                            <img :src="comment.user.large_profile" v-rjs="2" />
                        </div>

                        <!-- Username -->
                        <div class="activity-item-header">
                            <h3>
                                <a :href="`/${comment.user.username}`" class="person-hover-trigger" :data-user="comment.user.username">
                                    {{ comment.user.full_name }}
                                    <verified :user="user"></verified>
                                </a>

                                {{ diffForHumans(comment.created_at) }}
                            </h3>
                        </div>

                        <div class="activity-item-content" v-if="comment.body != null">
                            <p>{{ comment.body }}</p>
                        </div>

                        <!-- Activity in Comments -->
                        <div class="activity-item-comments" v-if="currentUser" >

                            <div class="activity-item-comments__top">
                                <button @click="comment.is_open = !comment.is_open" class="activity-item-comments-toggle">

                                    <svg class="comment-new">
                                        <use xlink:href="#comment-new"></use>
                                    </svg>

                                    <span v-if="comment.is_open">hide</span>

                                    {{ pluralize('Comment', comment.responses.length) }}

                                    <small v-show="comment.responses.length"
                                           v-text="`(${comment.responses.length})`">
                                    </small>
                                </button>

                                <LoveCommentToggle
                                    :post="post"
                                    :comment="comment"
                                    :user="currentUser" />
                            </div>

                            <CommentResponses :post="post"
                                              :comment="comment"
                                              :user="currentUser"
                                              @updated="comments[index] = $event"/>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--
        <button class='comments-load-more'>Load More</button>
        -->

        <form class="activity-item-comments__form blog-main-comment-form" @submit.prevent="saveComment()" v-if="currentUser">
            <img :src="currentUser.large_profile" v-rjs="2"/>
            <textarea placeholder="Leave a comment" v-model="commentForm.body"></textarea>
            <button type="submit" :class="{ 'dis': (!commentForm.body || commentForm.isSubmitted) }" :disabled="commentForm.isSubmitted">
                Post
            </button>
        </form>

    </div>
</template>
<script>

import { scrollIntoView } from "seamless-scroll-polyfill";
import Form from '@/classes/Form'
import Verified from '@/components/Verified'
import Helpers from '@/mixins/Helpers'
import CommentResponses from '@/components/Comments/Responses'
import LoveCommentToggle from '@/components/Comments/LoveToggle'

export default {

    mixins: [Helpers],

    components:{
        Verified,
        CommentResponses,
        LoveCommentToggle
    },

    props: ['post', 'user'],


    data() {
        return {
            currentUser: this.user,
            paginator: null,
            comments: [],
            commentCount: 0,
            commentForm: this.user ? new Form({
                body: '',
                user_id: this.user.id,
            }) : null
        }
    },

    mounted() {
        this.fetchComments();
        this.$nextTick(() => {
            setTimeout(() => {
                this.scrollToComments();
            }, 500)
        })
    },

    methods: {

        fetchComments() {
            axios.get(`/post/${this.post.slug}/comments?page=1`)
                .then(response => {
                    this.paginator = response.data.paginator;
                    this.comments.push(...response.data.comments);
                    this.commentCount = response.data.count;
                })
                .catch(errors => {
                    console.log(errors)
                });
        },

        saveComment() {
            this.commentForm.post(`/post/${this.post.slug}/comment`)
                .then((response) => {
                    this.comments.push(response.comment);
                    this.commentForm.user_id = this.user.id
                })
                .catch(errors => {
                    // this.errorMessage = response.data.content;
                })
        },

        scrollToComments() {


            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const commentsId = urlParams.get('comments')
            if(commentsId) {
                var element = document.getElementById(`section-comment-${commentsId}`);
                const offset = 40;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    },
}
</script>
